<script>
import Chart from "chart.js";
import { Bar, mixins } from "vue-chartjs";
import { EventBus } from "../main";
import moment from "moment";
import "chartjs-plugin-annotation";

const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "viewType", "chartAxis"],
  mounted() {
    Chart.defaults.global.defaultFontFamily = "Roboto";
    Chart.defaults.global.defaultFontColor = "#333";

    this.options.scales.yAxes[0].ticks.max = Number(this.chartAxis);

    this.renderChart(this.chartData, this.options);

    if (!this.listenerMounted) {
      EventBus.$on("updateChartOverview", this.updateChart);
      EventBus.$on("updateChartAxisOverview", this.updateAxis);
      this.listenerMounted = true;
    }
  },
  beforeDestroy: function() {
    EventBus.$off("updateChartOverview");
    EventBus.$off("updateChartAxisOverview");
  },
  methods: {
    updateChart() {
      this.options.scales.xAxes[0].time.unit =
        this.viewType == "week" ? "day" : "hour";
      this.renderChart(this.chartData, this.options);
    },
    updateAxis(max) {
      this.options.scales.yAxes[0].ticks.max = max;
      this.renderChart(this.chartData, this.options);
    }
  },
  data: () => ({
    listenerMounted: false,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          filter: function(item) {
            return item.text !== "";
          }
        }
      },
      tooltips: {
        mode: "nearest",
        callbacks: {
          beforeTitle: function(tooltipItem, data) {
            let dataset = data.datasets[tooltipItem[0].datasetIndex];
            return dataset.label;
          },
          title: function(tooltipItem, data) {
            let dataset = data.datasets[tooltipItem[0].datasetIndex];
            let value =
              tooltipItem[0].value +
              (dataset.yAxisID == "bg" ? " mmol/L" : " U");
            if (dataset.label === "Basal") {
              value =
                dataset.data[tooltipItem[0].index].userBasal +
                (dataset.yAxisID == "bg" ? " mmol/L" : " U");
            } else if (dataset.label === "Notifications") {
              value = "";
            } else if (dataset.label === "Notes") {
              value = "";
            }
            return value;
          },
          beforeLabel: function(tooltipItem, data) {
            let logData =
              data.datasets[tooltipItem.datasetIndex]["data"][
                tooltipItem.index
              ];
            let info = "";
            info += logData.override ? "Override\n" : "";
            info +=
              logData.userBasal && logData.userBasal !== logData.basaDose
                ? "Override\n"
                : "";
            info += logData.isCustomTimestamp ? "Retrospective log\n" : "";
            info += logData.bg ? "BG: " + logData.bg + " mmol/L\n" : "";
            info += logData.mealCHO
              ? "Meal amount: " + logData.mealCHO + " g\n"
              : "";
            info += logData.bolusMeal
              ? "Meal bolus: " + logData.bolusMeal + "\n"
              : "";
            info += logData.bolusCorr
              ? "Correction bolus: " + logData.bolusCorr + "\n"
              : "";
            info += logData.IOB ? "IOB: " + logData.IOB + "\n" : "";
            info +=
              logData.notes && logData.notes != ""
                ? "\nNotes: " + logData.notes + "\n"
                : "";

            info += "funcTitle" in logData ? logData.funcTitle + "\n" : "";
            info +=
              "success" in logData
                ? logData.success
                  ? "Status: Sent\n"
                  : "Status: Error\n"
                : "";
            if (info != "") {
              info = info.slice(0, -1);
            }
            return info;
          },
          label: function() {
            return null;
          },
          footer: function(tooltipItem) {
            return moment(tooltipItem[0].label).format("MMMM D, HH:mm");
          }
        },
        backgroundColor: "#f0f0f0",
        xPadding: 20,
        yPadding: 15,
        cornerRadius: 20,
        titleFontSize: 20,
        titleFontColor: "#000",
        bodyFontColor: "#555",
        bodyFontStyle: "bold",
        bodyFontSize: 13,
        footerFontColor: "#777",
        footerFontSize: 12,
        footerFontStyle: "normal",
        displayColors: false,
        caretPadding: 10
      },
      hover: {
        mode: "nearest",
        intersect: true
      },
      scales: {
        xAxes: [
          {
            display: true,
            type: "time",
            time: {
              unit: "day"
            },
            distribution: "linear",
            stacked: true
          }
        ],
        yAxes: [
          {
            id: "bg",
            type: "linear",
            position: "left",
            scaleLabel: {
              display: true,
              labelString: "Blood Glucose (mmol/L)"
            },
            ticks: {
              max: 22,
              min: 0,
              stepSize: 2
            }
          },
          {
            id: "insulin",
            type: "linear",
            position: "right",
            scaleLabel: {
              display: true,
              labelString: "Insulin Dose (U)"
            },
            ticks: {
              max: 44,
              min: 0,
              stepSize: 4
            }
          }
        ]
      },
      annotation: {
        annotations: [
          {
            type: "box",
            yScaleID: "bg",
            yMax: 10,
            yMin: 3.9,
            borderWidth: 1,
            borderColor: "rgba(0,0,0,0)",
            backgroundColor: "rgba(48, 76, 156, 0.15)"
          }
        ],
        drawTime: "afterDraw"
      }
    }
  })
};
</script>
